"use client"
import { motion } from "framer-motion"
import { useEffect, useState } from "react"
import { CollectionGrid } from "@/components/collection-grid"
import { COLLECTIONS } from "@/lib/api"

export function AnimatedCollections() {
  const [isVisible, setIsVisible] = useState(false)
  
  useEffect(() => {
    setIsVisible(true)
  }, [])

  return (
    <>
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={isVisible ? { opacity: 1, y: 0 } : { opacity: 0, y: -20 }}
        transition={{ duration: 0.6, ease: "easeOut" }}
      >
        <div className="mb-8">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4 tracking-tight font-funnel">
            Explore NFT Collections
          </h1>
          <p className="text-gray-600">
            Browse all available collections. Click on any collection to view it on OpenSea.
          </p>
        </div>
      </motion.div>
      
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={isVisible ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
        transition={{ duration: 0.6, ease: "easeOut", delay: 0.2 }}
      >
        <div className="w-full">
          <CollectionGrid collections={COLLECTIONS} />
        </div>
      </motion.div>
    </>
  )
}
